import { type FC } from "react";
import { PeopleType } from "../../../features/Library/PeopleAssignments/types";
import { type IObservable } from "interfaces";
import { TriggerableConfirmationModal } from "components/triggeredConfirmationModal/TriggerableConfirmationModal";
import { ModalSizes } from "enums";

export interface RemoveContentConfirmationModalProps {
  removeObserver: IObservable<(onSubmit: () => void) => void>;
  peopleType: PeopleType;
  onClose?: () => void;
}

const RemovePriorityConfirmationModal: FC<RemoveContentConfirmationModalProps> = (
  props: RemoveContentConfirmationModalProps,
) => {
  const { removeObserver, peopleType, onClose } = props;

  const content =
    peopleType === PeopleType.User
      ? "Are you sure you want to clear priorities? This action removes all priority settings, causing selected flow(s) to no longer appear on the home page for this user."
      : "Are you sure you want to clear priorities? This action removes all priority settings, causing selected flow(s) to no longer appear on the home page for all users in this group.";

  return (
    <TriggerableConfirmationModal
      onTriggerModalObserver={removeObserver}
      content={content}
      confirmButtonLabel={"Clear Priority"}
      title={"Clear Priority Settings?"}
      onClose={onClose}
      size={ModalSizes.tiny}
    />
  );
};

export default RemovePriorityConfirmationModal;
